import request from './request';

export default {
	async getEquipments(query) {
		const res = await request.get('/admin/equipments', query);
		return res;
	},
	async getEquipmentById(query) {
		const res = await request.get('/admin/equipments/id', query);
		return res;
	},
	async createEquipment(body) {
		const res = await request.post('/admin/equipments', body);
		return res;
	},
	async updateEquipmentById(id, body) {
		const res = await request.patch(`/admin/equipments/id?id=${id}`, body);
		return res;
	},
	async deleteEquipmentById(query) {
		const res = await request.delete('/admin/equipments/id', query);
		return res;
	},
	async getEquipmentUsageHistory(query) {
		const res = await request.get('/admin/equipments/id/usage-history', query);
		return res;
	},
	async toggleEquipmentController(query) {
		const res = await request.post(`/admin/equipments/id/toggle-controller?id=${query.id}&action=${query.action}`);
		return res;
	}
};
